var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
const BASE = '/api/internal/customer_file_drops';
export function getFolders() {
    return __awaiter(this, arguments, void 0, function* (page = 1, perPage = 25, q = undefined) {
        const params = { page, per_page: perPage };
        if (q)
            params.q = q;
        const response = yield api.get(`${BASE}/folders`, { params });
        return response.data;
    });
}
export function getFolder(folderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(`${BASE}/folders/${folderId}`);
        return response.data.folder;
    });
}
export function createFolder(name, expiresAt, description) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders`, {
            folder: { name, expires_at: expiresAt, description: description || undefined }
        });
        return response.data;
    });
}
export function updateFolder(folderId, attrs) {
    return __awaiter(this, void 0, void 0, function* () {
        const folder = {};
        if (attrs.name != null)
            folder.name = attrs.name;
        if (attrs.description != null)
            folder.description = attrs.description;
        if (attrs.expiresAt != null)
            folder.expires_at = attrs.expiresAt;
        const response = yield api.patch(`${BASE}/folders/${folderId}`, {
            folder
        });
        return response.data.folder;
    });
}
export function deleteFolder(folderId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(`${BASE}/folders/${folderId}`);
    });
}
export function getFiles(folderId_1) {
    return __awaiter(this, arguments, void 0, function* (folderId, page = 1, perPage = 50, search = undefined) {
        const params = { page, per_page: perPage };
        if (search)
            params.search = search;
        const response = yield api.get(`${BASE}/folders/${folderId}/files`, { params });
        return response.data;
    });
}
export function presignUploads(folderId, files) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders/${folderId}/presign_uploads`, { files });
        return response.data;
    });
}
export function confirmUploads(folderId, files) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.post(`${BASE}/folders/${folderId}/confirm_uploads`, { files });
    });
}
export function getDownloadUrl(folderId, fileId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders/${folderId}/files/${fileId}/download`);
        return response.data;
    });
}
export function deleteFile(folderId, fileId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.delete(`${BASE}/folders/${folderId}/files/${fileId}`);
    });
}
export function extractZip(folderId, fileId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders/${folderId}/files/${fileId}/extract`);
        return response.data;
    });
}
export function retryExtract(folderId, fileId) {
    return __awaiter(this, void 0, void 0, function* () {
        return extractZip(folderId, fileId);
    });
}
export function lockFolder(folderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders/${folderId}/lock`);
        return response.data.folder;
    });
}
export function unlockFolder(folderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.post(`${BASE}/folders/${folderId}/unlock`);
        return response.data.folder;
    });
}
export function getAllowlistUsers(search_1) {
    return __awaiter(this, arguments, void 0, function* (search, page = 1, perPage = 20) {
        const params = { page, per_page: perPage };
        if (search)
            params.search = search;
        const response = yield api.get(`${BASE}/allowed_users`, { params });
        return response.data;
    });
}
export function updateAllowlist(userIds) {
    return __awaiter(this, void 0, void 0, function* () {
        yield api.put('/customer_file_drop', { tenant: { customer_file_drop_allowed_user_ids: userIds } }, { headers: { Accept: 'application/json' } });
    });
}
